import React from 'react';
import { useTranslation } from 'react-i18next';
import { BOOL } from '@tencent/wemeet-websdk-next';

import wemeetClient from '@utils/wemeetClient';

import { HostShareCtrlProps } from './HostShareCtrl.type';

import './HostShareCtrl.scss';

const HostShareCtrl: React.FC<HostShareCtrlProps> = (props) => {
  const { t } = useTranslation();

  const muteShare = () => {
    if (props.user.id) {
      wemeetClient.hostCtrl.muteShare(props.user.id, BOOL.false);
    }
  };

  return (
    <li className="host-video-ctrl" onClick={muteShare}>
      {t('停止共享')}
    </li>
  );
};

export default HostShareCtrl;
